/**
 * cal.com — Terminbuchung als Modal/Lightbox auf der Seite.
 * Portiert von der VAUPEL-Website: Klick auf einen beliebigen
 * "Termin buchen"-Link (href enthält cal.com) öffnet das offizielle
 * cal.com-Embed-Modal statt die Seite zu verlassen; der Hintergrund
 * wird abgedunkelt und geblurrt.
 *
 * Konfiguration kommt aus window.VAUPEL_CAL (gerendert in theme.liquid):
 *   { link: "vaupel-gerbstedt", brand: "#1E3A5F" }
 * Fallback ohne JS/Embed: Links funktionieren normal (neuer Tab zu cal.com).
 */
(function () {
  'use strict';
  var cfg = window.VAUPEL_CAL || {};
  var CAL_LINK = cfg.link;
  var BRAND = cfg.brand || '#1E3A5F';
  if (!CAL_LINK) return;

  // Offizieller cal.com Embed-Loader
  (function (C, A, L) {
    var p = function (a, ar) { a.q.push(ar); };
    var d = C.document;
    C.Cal = C.Cal || function () {
      var cal = C.Cal; var ar = arguments;
      if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; }
      if (ar[0] === L) {
        var api = function () { p(api, arguments); };
        var namespace = ar[1]; api.q = api.q || [];
        if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); }
        else p(cal, ar);
        return;
      }
      p(cal, ar);
    };
  })(window, 'https://app.cal.com/embed/embed.js', 'init');

  try {
    window.Cal('init', { origin: 'https://cal.com' });
    window.Cal('ui', {
      theme: 'light',
      cssVarsPerTheme: { light: { 'cal-brand': BRAND }, dark: { 'cal-brand': BRAND } },
      hideEventTypeDetails: false,
      layout: 'month_view'
    });
  } catch (e) { /* Embed nicht erreichbar — Links bleiben als Fallback nutzbar */ }

  // Event-Delegation: fängt auch Links in dynamisch nachgeladenen Bereichen
  // (Cart-Drawer, Section-Rerender im Theme-Editor) zuverlässig ab.
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // neuer Tab bleibt möglich
    var a = e.target.closest && e.target.closest('a[href*="cal.com/"], [data-cal-booking]');
    if (!a) return;
    if (!window.Cal) return; // ohne Embed: normaler Link
    e.preventDefault();
    // Welcher cal.com-Event? Reihenfolge:
    //   1. data-cal-link="vaupel-gerbstedt/hochzeit"  (expliziter Override)
    //   2. Event-Slug aus dem href  (…cal.com/vaupel-gerbstedt/hochzeit)
    //   3. globaler Standard-Kalender  (window.VAUPEL_CAL.link)
    // So öffnet z. B. der Hochzeits-Button nur Hochzeitstermine.
    var link = a.getAttribute('data-cal-link');
    if (!link) {
      var href = a.getAttribute('href') || '';
      var m = href.match(/cal\.com\/([^?#]+)/);
      link = m ? decodeURIComponent(m[1]) : CAL_LINK;
    }
    window.Cal('modal', { calLink: link, config: { layout: 'month_view', theme: 'light' } });
  });

  // cal.com bringt einen eigenen Backdrop (.my-backdrop) im offenen Shadow-DOM mit.
  // Wir stylen ihn direkt: dunkler + geblurrt, passend zur Marke.
  function styleCalBackdrop() {
    var modal = document.querySelector('cal-modal-box');
    if (!modal || !modal.shadowRoot) return;
    if (modal.getAttribute('state') === 'closed') return;
    var ov = modal.shadowRoot.querySelector('.my-backdrop');
    if (ov && !ov.__vpStyled) {
      ov.__vpStyled = true;
      ov.style.background = 'rgba(20,22,26,.66)';
      ov.style.backdropFilter = 'blur(14px) saturate(.9)';
      ov.style.webkitBackdropFilter = 'blur(14px) saturate(.9)';
    }
  }

  var bodyObserver = new MutationObserver(function () {
    var modal = document.querySelector('cal-modal-box');
    if (modal && !modal.__vpWatched) {
      modal.__vpWatched = true;
      new MutationObserver(styleCalBackdrop).observe(modal, { attributes: true, attributeFilter: ['state'] });
      [60, 200, 500].forEach(function (t) { setTimeout(styleCalBackdrop, t); });
    }
    styleCalBackdrop();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
